import { css, type Theme } from "@emotion/react";

export { visuallyHidden } from "@styles/emotion-styles/utilities";

export const priceGroup = (theme: Theme) => css`
  display: inline-flex;
  align-items: baseline;
  gap: ${theme.ds5.spacing.gap.xsmall};
`;
